//@ts-nocheck
import React, { useContext, useState, useEffect } from "react";
import propTypes from "prop-types";

import Context from "../../ContextProvider";

import FormSection from "./FormSection";

function CustomerForm({ results, updateSection }) {
  const { form } = useContext<any>(Context);
  const diagnosticForm = form.filter(
    ({ key }) => key !== "personalDetails" && key !== "solutions"
  );

  // Zustand für das Textfeld hinzufügen
  const [textFieldValue, setTextFieldValue] = useState("");
  const [isTextFieldDisabled, setIsTextFieldDisabled] = useState(true);

  // console.log('CustomerDiagnosticForm', diagnosticForm);
  // console.log('results', results);
  // console.log('updateSection', updateSection);
  // console.log('textFieldValue', textFieldValue);
  // console.log('isTextFieldDisabled', isTextFieldDisabled);

  // Initialisiere den Zustand basierend auf den vorhandenen Daten
  useEffect(() => {
    const isCheckboxChecked = results?.sonstigesTextCheck || false;
    const initialTextFieldValue = results?.sonstigesText || "";

    // Wenn ein Wert im Textfeld vorhanden ist, aktiviere die Checkbox und das Textfeld
    if (initialTextFieldValue) {
      setIsTextFieldDisabled(false);
      updateSection("sonstigesTextCheck", true); // Checkbox aktivieren
    } else {
      setIsTextFieldDisabled(!isCheckboxChecked);
    }
    
    setTextFieldValue(initialTextFieldValue);
  }, [results?.sonstigesText, results?.sonstigesTextCheck]);

  const handleCheckboxChange = (idName: string, isChecked: boolean) => {
    if (idName === "sonstigesTextCheck") {
      setIsTextFieldDisabled(!isChecked); // Aktiviert oder deaktiviert das Textfeld
      if (!isChecked) {
        setTextFieldValue(""); // Setzt den Wert des Textfelds zurück
        updateSection("sonstigesText", ""); // Löscht den Wert im übergeordneten Zustand
      }
      updateSection("sonstigesTextCheck", isChecked); // Aktualisiere die Daten
    }
  };

  const handleTextFieldChange = (idName: string, value: string) => {
    if (idName === "sonstigesText") {
      setTextFieldValue(value); // Aktualisiert den Wert des Textfelds
      updateSection("sonstigesText", value); // Aktualisiere die Daten

      // Wenn ein Wert eingegeben wird, aktiviere die Checkbox
      if (value) {
        updateSection("sonstigesTextCheck", true);
        setIsTextFieldDisabled(false);
      }
    }
  };

  const handleTextFieldKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Verhindert das Absenden des Formulars
    }
  };

  if (!diagnosticForm) return null;
  return (
    <>
      {diagnosticForm.map((section) => (
        <FormSection
          key={section.key}
          results={results[section.key]}
          section={section}
          updateSection={updateSection}
          onCheckboxChange={handleCheckboxChange}
          onTextFieldChange={handleTextFieldChange}
          textFieldValue={results[section.key]?.sonstigesText || ""}
          isTextFieldDisabled={isTextFieldDisabled}
          onKeyDown={handleTextFieldKeyDown} // Event-Handler hinzufügen
        />
      ))}
    </>
  );
}
CustomerForm.propTypes = {
  updateSection: propTypes.func.isRequired,
  results: propTypes.instanceOf(Object).isRequired,
};

export default CustomerForm;
